import { Drawer } from "antd";
import { DraftPage } from "./Draft/DraftPage";

interface CampaignScriptingDrawerProps {
  open: boolean;
  onClose: () => void;
  draftId: string;
  refetchInfluencer?: () => void;
}

export default function CampaignDraftDrawer({
  open,
  onClose,
  draftId,
  refetchInfluencer = () => {},
}: CampaignScriptingDrawerProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={null}
      width={1300}
      closeIcon={false}
      footer={null}
      styles={{
        body: {
          padding: 0,
        },
        header: {
          display: "none",
        },
      }}
    >
      <DraftPage
        draftingId={draftId}
        onClose={onClose}
        refetchInfluencer={refetchInfluencer}
      />
    </Drawer>
  );
}
